module.exports = __webpack_public_path__ + "static/media/flatterme.6e7cc189.png";